window.select2NewUser = function() {
  $('#user_sys_account_id').select2({          
    dropdownParent: $('.modal'),
    placeholder: 'Choose|an|user',
    templateResult: function(data) {
      var r = data.text.split('|');
      var result = jQuery(
          '<div class="row">' +
              '<div class="col-md-4 py-0 text-sm">' + r[0] + '</div>' +
              '<div class="col-md-4 py-0 text-sm">' + r[1] + '</div>' +
              '<div class="col-md-4 py-0 text-sm">' + r[2] + '</div>' +
          '</div>'
      );
      return result;
    },
    templateSelection: function(data) {
      var r = data.text.split('|');
      var result = `${r[0]} - ${r[1]} - ${r[2]}`
      return result;
    }
  });

  $('#user_sys_account_id').on('select2:open', function () {
    if ($('.select2-sticky-top').length === 0) {
      let stickyDiv = `
        <div class="row select2-sticky-top">
          <div class="col-4 py-0">Username</div>
          <div class="col-4 py-0">NIK</div>
          <div class="col-4 py-0">Name</div>
        </div>
      `;
      $('.select2-results').prepend(stickyDiv);
    }
  });
};
